import {
  BarChart3,
  Building2,
  Lightbulb,
  Scale,
  Settings as SettingsIcon
} from "lucide-react";
import clsx from "clsx";
import type { TabKey } from "@/app/store";

interface TabBarProps {
  activeTab: TabKey;
  onSelect: (tab: TabKey) => void;
}

const tabs: Array<{ id: TabKey; label: string; icon: typeof BarChart3 }> = [
  { id: "dashboard", label: "Review", icon: BarChart3 },
  { id: "properties", label: "Properties", icon: Building2 },
  { id: "scenarios", label: "Scenarios", icon: Scale },
  { id: "insights", label: "Insights", icon: Lightbulb },
  { id: "settings", label: "Settings", icon: SettingsIcon }
];

export const TabBar = ({ activeTab, onSelect }: TabBarProps) => (
  <nav
    className="fixed bottom-2 left-2 right-2 z-20 grid grid-cols-5 gap-1 rounded-2xl border border-app bg-app-surface/95 p-2 backdrop-blur"
    aria-label="Main navigation"
    data-testid="tabbar"
  >
    {tabs.map((tab) => {
      const Icon = tab.icon;
      const isActive = tab.id === activeTab;
      return (
        <button
          key={tab.id}
          type="button"
          className={clsx(
            "flex flex-col items-center rounded-xl px-1 py-2 text-[11px] transition",
            isActive
              ? "bg-app-primary text-[color:var(--color-on-primary)]"
              : "text-app-soft hover:bg-app-surface-muted"
          )}
          onClick={() => onSelect(tab.id)}
          aria-label={tab.label}
          aria-current={isActive ? "page" : undefined}
          data-testid={`tab-${tab.id}`}
        >
          <Icon size={16} />
          <span>{tab.label}</span>
        </button>
      );
    })}
  </nav>
);
